// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollToTopButton_button__3jQtm"};